import actions from './actions';
import reducer from './reducer';

const reports = {
    actions,
    reducer,
    name: 'reports',
};

export default reports;